import * as THREE from 'three';
import { WebGLElement } from './base.js';

function parsePoints(s) {
  if (!s) return new Float32Array();
  const nums = String(s).trim().split(/\s+/).map(Number);
  if (nums.some(Number.isNaN)) return new Float32Array();
  const usable = nums.length - (nums.length % 3);
  return new Float32Array(nums.slice(0, usable));
}

export class ThreeLine extends WebGLElement {
  static properties = {
    ...WebGLElement.properties,
    points: { type: String },
    color: { type: String },
    closed: { type: Boolean },
    linewidth: { type: Number },
  };

  constructor() {
    super();
    this.points = '0 0 0 1 0 0';
    this.color = '#ffffff';
    this.closed = false;
    this.linewidth = 1;
  }

  _buildGeometry() {
    const arr = parsePoints(this.points);
    const geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(arr, 3));
    return geo;
  }

  createObject3D() {
    const geo = this._buildGeometry();
    const mat = new THREE.LineBasicMaterial({
      color: new THREE.Color(this.color),
      linewidth: this.linewidth,
    });
    const Ctor = this.closed ? THREE.LineLoop : THREE.Line;
    return new Ctor(geo, mat);
  }

  updated(changed) {
    super.updated(changed);
    if (!this.object3D) return;
    if (changed.has('points')) {
      this.object3D.geometry.dispose();
      this.object3D.geometry = this._buildGeometry();
    }
    if (changed.has('color')) {
      this.object3D.material.color.set(this.color);
    }
    if (changed.has('linewidth')) {
      this.object3D.material.linewidth = this.linewidth;
      this.object3D.material.needsUpdate = true;
    }
    if (changed.has('closed')) {
      const parent = this.object3D.parent;
      const geo = this.object3D.geometry;
      const mat = this.object3D.material;
      if (parent) parent.remove(this.object3D);
      const Ctor = this.closed ? THREE.LineLoop : THREE.Line;
      this.object3D = new Ctor(geo, mat);
      this.applyTransform();
      if (parent) parent.add(this.object3D);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.object3D) {
      this.object3D.geometry?.dispose();
      this.object3D.material?.dispose();
    }
  }
}

customElements.define('three-line', ThreeLine);
